<script lang="ts">
	import Dots from './dots.svg.svelte';

	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class="rotate-90">
	<Dots {className} />
</div>
